module.exports = function(app) {
    app.run(['Service', function(Service) {
            new Service({

                name: 'getGroupName',
                group:'rbsmbl',
                url:'/rbsmbl/x-services/public/provider/v1/data/plan/info',

                fetch: function(groupNumber) {
                    return this.get({ group: groupNumber });
                }
            });
        }
    ]);
};
